import { alertV3Service } from "cortex/ui/src/fleet/service/alertV3";
import { createApiSaga } from "cortex/ui/src/redux-store/api-sagas/sagas";

import {
  CREATE_ALERT_V3,
  CREATE_ALERT_V3_SUCCESS,
  DELETE_ALERT_V3,
  DELETE_ALERT_V3_SUCCESS,
  EDIT_ALERT_V3,
  EDIT_ALERT_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
  LOAD_ALERTS_V3_SUCCESS,
} from "./actions";

const reloadAlertsV3Saga = createApiSaga({
  service: alertV3Service.load,
  serviceName: "alertV3Service.load",
  successAction: LOAD_ALERTS_V3_SUCCESS,
  failureAction: LOAD_ALERTS_V3_FAILURE,
  reload: true,
});

const createAlertV3Saga = createApiSaga({
  fetchAction: CREATE_ALERT_V3,
  service: alertV3Service.new,
  serviceName: "alertV3Service.new",
  successAction: CREATE_ALERT_V3_SUCCESS,
  reload: false,
});

const deleteAlertV3Saga = createApiSaga({
  fetchAction: DELETE_ALERT_V3,
  service: alertV3Service.delete,
  serviceName: "alertV3Service.delete",
  successAction: DELETE_ALERT_V3_SUCCESS,
  reload: false,
});

const editAlertV3Saga = createApiSaga({
  fetchAction: EDIT_ALERT_V3,
  service: alertV3Service.edit,
  serviceName: "alertV3Service.edit",
  successAction: EDIT_ALERT_V3_SUCCESS,
  reload: false,
});

const alertV3Sagas = [
  createAlertV3Saga(),
  deleteAlertV3Saga(),
  editAlertV3Saga(),
  reloadAlertsV3Saga(),
];

export { alertV3Sagas };
